import Cookies from 'js-cookie';

export const isAuthorized = (): boolean => {
  return Boolean(Cookies.get('accesstoken'));
};
